import type { StateBlock, StateInline, TagToken } from 'remarkable/lib';
import type { Remarkable } from 'remarkable';
import { TMDTocProps } from './builder/elements/tableOfContents';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ErrorImporting {}

export type IMarkdownHtml = (
  title: string,
  css: string,
  body: string,
) => string;

export type IMarkdownParser = (
  options: IMarkdownConfiguration,
) => Promise<string>;

export interface IMarkdownConfiguration {
  /**
   * Cadena de caracteres de CSS
   */
  additionalStyles?: IMarkdownStylesAggregator;
  /**
   * Permite agregar contenido al body del html generado.
   */
  additionalBodyContent?: Partial<{ before: string; after: string }>;
  /**
   * Contenido markdown
   */
  content: string;
  /**
   * Permite el pasaje de extensiones adicionales
   */
  extensions?: RemarkableExtension[];
  /**
   * Si el template html por defecto no es suficiente, se puede optar por un
   * template a medida.
   */
  htmlTemplate?: IMarkdownHtml;
  /**
   * If passed, will print the table of contents with the indicated title.
   */
  tocProps?: TMDTocProps;
  /**
   * Título que se mostrará en el html
   */
  title: string;

  tableOfContentsTitle?: string;
}

export interface IRemarkableInlineExtension {
  name: string;
  parser: (state: StateInline, checkMode: boolean) => boolean;
  replacer: (md: Remarkable) => (tokens: TagToken[], idx: number) => string;
  styles: () => string;
}

export interface IRemarkableBlockExtension {
  name: string;
  parser: (
    state: StateBlock,
    startLine: number,
    endLine: number,
    checkMode: boolean,
  ) => boolean;
  replacer: (md: Remarkable) => (tokens: TagToken[], idx: number) => string;
  styles: () => string;
}

export type RemarkableExtension =
  | IRemarkableInlineExtension
  | IRemarkableBlockExtension;

export type IMarkdownStylesAggregator = () => string;
